export const STATUS_META = {
  new: { label: "New", color: "#002FA7" },
  report_sent: { label: "Report Sent", color: "#FF4500" },
  contacted: { label: "Contacted", color: "#8B5CF6" },
  warm: { label: "Warm", color: "#FFB300" },
  qualified: { label: "Qualified", color: "#00C853" },
  closed: { label: "Closed", color: "#525252" },
};

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || { label: status, color: "#525252" };
  return (
    <span
      className="font-data text-[10px] font-bold uppercase tracking-wider px-2 py-1 border-2 whitespace-nowrap"
      style={{ color: m.color, borderColor: m.color }}
    >
      {m.label}
    </span>
  );
};

export default StatusBadge;
